import { createStore } from 'vuex'
import Toast from '@/plugins/toast';
import axios from '@/plugins/axios';
import { useFavicon } from '@vueuse/core'
import Swal from "sweetalert2";


export default createStore({
  state: {
    siteName:'بک لینک',
    user:{
      'full_name':localStorage.getItem('full_name'),
      'id':localStorage.getItem('id'),
      'token':localStorage.getItem('token'),
      'access':localStorage.getItem('access'),
      'avatar':localStorage.getItem('avatar'),
      'status':localStorage.getItem('status'),
    },
    apiUrl:"https://backend.shomanet.ir/api/",
    baseApiUrl:"https://backend.shomanet.ir",
    frontUrl: "https://shomanet.ir",
    baseUrl: "shomanet.ir",
    schema: "https://",
    // apiUrl:"http://localhost:8000/api/",
    // baseApiUrl:"http://localhost:8000",
    // frontUrl: "http://localhost:3000",
    // baseUrl: "localhost:3000",
    // schema: "http://",
    toggleSideBar: false,
    errors:[],
    permissions:[],
    userPermissions:[],


  },
  mutations: {
    copy(state, payload){
      navigator.clipboard.writeText(payload);
      Toast.success("با موفقیت کپی شد")
    },

    paginate(state, {current_page, to, per_page, last_page}){
      state.current = current_page;
      state.next = to;
      state.previous = per_page;
      state.total = last_page;
    },

    handleError(state, payload) {
      const response = payload?.response;
      if (!response || response.status === 500) {
        const msg = response?.data?.msg || "یک خطای غیرمنتظره رخ داده است";
        Toast.error(msg)
        return;
      }

      switch (response.status) {
        case 422:
        case 413:
          state.errors = Object.values(response.data.errors || {});
          state.validationErrorModal = true;
          break;

        case 401:
          this.commit('clearStorage')
          window.location.href = `/login`;
          break;
        case 403:
          window.location.href = `/error/${response.status}/${encodeURIComponent(
            "دسترسی شما غیر مجاز است، برای بررسی بیشتر با ما تماس بگیرید"
          )}`;
          break;

        case 404:
          // window.location.href = `/error/404/${encodeURIComponent(
          //   "صفحه مورد نظر پیدا نشد"
          // )}`;
          break;

        default: 
          // const msg =
          //   response.data?.msg || `خطای ${response.status} رخ داده است`;
          // window.location.href = `/error/${response.status}/${encodeURIComponent(
          //   msg
          // )}`;
          break;
      }
    },
    async setStorage(state, payload){
      const setToken = payload[0]
      const userData = payload[1]
      localStorage.setItem('full_name',userData.full_name);
      localStorage.setItem('id',userData.id);
      localStorage.setItem('avatar',userData.avatar);
      localStorage.setItem('access',userData.access);
      localStorage.setItem('status',userData.status);
      state.user.full_name = userData.full_name;
      state.user.id = userData.id;
      state.user.avatar = userData.avatar;
      state.user.access = userData.access;
      state.user.status = userData.status;

      if(setToken){
        localStorage.setItem('token',userData.token)
        state.user.token = userData.token;
      }

      await this.dispatch('setCookie', 'expire_token');

    },

    clearStorage(state){
      document.cookie = 'expire_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      state.user.full_name = null;
      state.user.id = null;
      state.user.avatar = null;
      state.user.access = null;
      state.user.status = null;
      state.user.token = null;
      const darkMode = localStorage.getItem('dark-mode')
      localStorage.clear()
      if (darkMode !== null) {
        localStorage.setItem('dark-mode', darkMode);
      }
    }

  },
  actions: {
    setFavicon({state}, favicon){
      const icon = useFavicon()
      icon.value = favicon
    },
    async setCookie({state},name) {
      let expires = "";
      let date = new Date();
      let timestamp = date.setTime(date.getTime() + (24*60*60*100));
      expires = "; expires=" + date.toUTCString();
      document.cookie = name + "=" + timestamp  + expires + "; path=/";
    },

    async deleteRecord({commit,state},payload){
      await Swal.fire({
        title: "آیا از حذف این ایتم مطمئنید؟",
        text: payload[1],
        icon: "warning",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'بله',
        denyButtonText: `خیر`,

      }).then(async (willDelete) => {
        if (willDelete.isConfirmed) {
          state.isLoading  = true;
          await axios.delete(state.apiUrl+payload[0]).then(resp=>{
            if(resp.data.status === 'success'){
              Swal.fire({
                title:'ایتم مورد نظر با موفقیت حذف شد',
                icon: "success",
                showDenyButton: true,
                showConfirmButton: false,
                denyButtonText: `بستن`,
              });
            }else {
              Swal.fire({
                title:'حذف با خطا مواجه شد.',
                icon: "error",
                showDenyButton: true,
                showConfirmButton: false,
                denyButtonText: `بستن`,
              });
            }
          }).catch(err=>{
            state.isLoading = false;
            commit('handleError',err)
          })
        }
      });
    },
  },
  getters: {
   
    dateToPersian:(state)=>(date)=>{
      return new Date(date).toLocaleDateString('fa-IR-u-nu-latn');
    },
    numberFormat:(state)=>(number)=>{
      return new Intl.NumberFormat().format(number);
    },
    imageType:(state)=>(image)=>{
      if(image !== null){
        let imageType = image.split('.')
        return 'image/' +  imageType[imageType - 1];
      }else{
        return 'image/jpeg'
      }
    },

    readTime:(state)=>(content)=>{
      if(content !== null && content.length > 0){
        const words = content.split(' ');
        let timeForRead = Math.trunc((words.length * 0.12) / 60);
        return timeForRead === 0 ? 'کمتر از 1 دقیقه' : timeForRead + ' دقیقه '
      }else{
        return "کمتر از 1 دقیقه"
      }
    },
    getToken(state){
      return state.user.token;
    },
    getErrors(state){
      return state.errors;
    },
    getCookie: (state) => (name) => {
      let nameEQ = name + "=";
      let ca = document.cookie.split(';');
      for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) {
          return c.substring(nameEQ.length,c.length)
        }
      }
      return null;
    },
    userCan: (state) => (permission,filter='') => {
      if(state.user.access === 'admin'){
        if(filter === 'include'){
          return state.userPermissions.filter(item=>item.includes(permission)).length > 0
        }else{
          return state.userPermissions.filter(item=>item === permission).length > 0
        }
      }else{
        return true;
      }
    },

    findMeta: (state) => (key, metas) => {
      let meta = metas.find(m=>m.meta_key === key);
      return meta ? meta.meta_value : '';
    },
  }
})
